import { AddToCart } from "./add-to-cart.js";
import { Box, Chip, Stack, Typography, useTheme } from "@mui/material";
import { LocalizationContext } from "../../localization/index.js";
import { makeCurrencyFormatter, price } from "../utils.js";
import { NumberOfPlayersChip } from "../number-of-players-chip.js";
import { ProductContext } from "../provider.js";
import { useMediaQuery } from "../../utilities/index.js";
import { useTranslation } from "next-i18next";
import { Variants } from "./variants.js";
import React from "react";
export const ProductMain = ({ addToCartBtnRef, showPrice = true }) => {
    const { t } = useTranslation("c-product");
    const theme = useTheme();
    const isAtLeastLg = useMediaQuery(theme.breakpoints.up("lg"));
    const product = React.useContext(ProductContext);
    const { offers } = product;
    const { market } = React.useContext(LocalizationContext);
    const { amount, currency } = price({ product, market });
    const offer = offers.find((o) => o.market === market);
    const formatCurrency = makeCurrencyFormatter({ currency: offer?.currency ?? currency });
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: "row", spacing: 1 },
            product.ean === "4262481821017" ? (React.createElement(Chip, { label: "EAN 4262481821017", size: isAtLeastLg ? "medium" : "small" })) : (React.createElement(NumberOfPlayersChip, { product: product })),
            product.edition === "online" && (React.createElement(Chip, { label: t("online-version-label", "Online-Version"), size: isAtLeastLg ? "medium" : "small", variant: "outlined" }))),
        React.createElement(Box, { sx: { mt: { xs: 0.75, md: 1, lg: 1.5, xl: 2 } } },
            React.createElement(Typography, { sx: { pt: 0, pb: 0 }, component: "h1", variant: "h2" }, product.title)),
        showPrice && (React.createElement(Stack, { alignItems: "baseline", direction: "row", spacing: 1, sx: { mt: 0 } },
            React.createElement(Typography, { sx: { pt: 0, pb: 0 }, variant: "h3" }, formatCurrency(offer?.price ?? amount)),
            React.createElement(Typography, { sx: { pt: 0, pb: 0 }, variant: "caption" }, t("inclusive-vat", "inkl. MwSt.")))),
        React.createElement(Box, { sx: { mt: 4 } },
            React.createElement(Typography, { component: "div", dangerouslySetInnerHTML: { __html: product.teaser }, paragraph: true, sx: { "& > p": { mb: 3, maxWidth: "70ch" } }, variant: "body1" })),
        product.alternativeEditions.length > 0 && React.createElement(Variants, null),
        React.createElement(AddToCart, { addToCartBtnRef: addToCartBtnRef })));
};
//# sourceMappingURL=main.js.map